import {
    ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_REQUEST,
    ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_SUCCESS,
    ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_FAIL,
    ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_RESET,
    GET_VERIFICATION_PROCESS_ASSIGNMENTS_REQUEST,
    GET_VERIFICATION_PROCESS_ASSIGNMENTS_SUCCESS,
    GET_VERIFICATION_PROCESS_ASSIGNMENTS_FAIL,
    GET_VERIFICATION_PROCESS_ASSIGNMENTS_RESET,
    UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_REQUEST,
    UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_SUCCESS,
    UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_FAIL,
    UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_RESET,
    DELETE_VERIFICATION_PROCESS_ASSIGNMENT_REQUEST,
    DELETE_VERIFICATION_PROCESS_ASSIGNMENT_SUCCESS,
    DELETE_VERIFICATION_PROCESS_ASSIGNMENT_FAIL,
    DELETE_VERIFICATION_PROCESS_ASSIGNMENT_RESET,
} from '../constants/verificationAssignProcessConstant'

export const assignVerificationProcessesToProcessManagerReducer = (state = {}, action) => {
    switch (action.type) {
        case ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_REQUEST:
            return { loadingAssignVerificationProcesses: true }
        case ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_SUCCESS:
            return {
                loadingAssignVerificationProcesses: false,
                assignVerificationProcessesData: action.payload,
            }
        case ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_FAIL:
            return {
                loadingAssignVerificationProcesses: false,
                errorAssignVerificationProcesses: action.payload,
            }
        case ASSIGN_VERIFICATION_PROCESSES_TO_PROCESS_MANAGER_RESET:
            return {}
        default:
            return state
    }
}

export const getVerificationProcessAssignmentsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_VERIFICATION_PROCESS_ASSIGNMENTS_REQUEST:
            return { loadingVerificationProcessAssignments: true }
        case GET_VERIFICATION_PROCESS_ASSIGNMENTS_SUCCESS:
            return {
                loadingVerificationProcessAssignments: false,
                verificationProcessAssignmentsData: action.payload,
            }
        case GET_VERIFICATION_PROCESS_ASSIGNMENTS_FAIL:
            return {
                loadingVerificationProcessAssignments: false,
                errorVerificationProcessAssignments: action.payload,
            }
        case GET_VERIFICATION_PROCESS_ASSIGNMENTS_RESET:
            return {}
        default:
            return state
    }
}

export const updateVerificationProcessAssignmentReducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_REQUEST:
            return { loadingUpdateVerificationProcessAssignment: true }
        case UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_SUCCESS:
            return {
                loadingUpdateVerificationProcessAssignment: false,
                updateVerificationProcessAssignmentData: action.payload,
            }
        case UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_FAIL:
            return {
                loadingUpdateVerificationProcessAssignment: false,
                errorUpdateVerificationProcessAssignment: action.payload,
            }
        case UPDATE_VERIFICATION_PROCESS_ASSIGNMENT_RESET:
            return {}
        default:
            return state
    }
}

export const deleteVerificationProcessAssignmentReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_VERIFICATION_PROCESS_ASSIGNMENT_REQUEST:
            return { loadingDeleteVerificationProcessAssignment: true }
        case DELETE_VERIFICATION_PROCESS_ASSIGNMENT_SUCCESS:
            return {
                loadingDeleteVerificationProcessAssignment: false,
                deleteVerificationProcessAssignmentData: action.payload,
            }
        case DELETE_VERIFICATION_PROCESS_ASSIGNMENT_FAIL:
            return {
                loadingDeleteVerificationProcessAssignment: false,
                errorDeleteVerificationProcessAssignment: action.payload,
            }
        case DELETE_VERIFICATION_PROCESS_ASSIGNMENT_RESET:
            return {}
        default:
            return state
    }
}